<div
  [ngClass]="groupClassList"
  class="med-radio"
>
  <med-label
    *ngFor="let option of options"
    [mode]="labelMode"
    [name]="option.id"
    [label]="option.label"
    [labelClass]="labelClass"
    [required]="option.required"
    [disabled]="option.disabled"
    [active]="compare(option.value)"
    class="med-radio__group-item"
  >
    <div class="med-radio__group">
      <input
        type="radio"
        class="med-radio__input"
        [id]="option.id"
        [name]="name"
        [disabled]="option.disabled"
        [required]="option.required"
        [value]="option.value"
        [(ngModel)]="value"
        (change)="onInput.emit(value)"
      />

      <div
        [ngClass]="classList"
        class="field med-radio__box"
      ></div>
    </div>
  </med-label>
</div>

<div
  *ngIf="invalid"
  class="field__error-message"
>
  {{ errorMessage }}
</div>
